import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { settingServices } from "Utils/setting/services";
import BreadCrumb from "Common/BreadCrumb";

//styles
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import ExposureModal from "Common/Modals/ExposureModal";

const UserDataUpdata: React.FC = () => {
  const [userData, setUserData] = useState<any[]>([]);
  const [agent, setAgentData] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [userIds, setUserIds] = useState<string>("");
  const [showExposure, setExposure] = useState(false);
  const [userName, setUserName] = useState("");

  const getUsersByLiability = async () => {
    try {
      const { response } = await settingServices.getUsersByLiability({});
      setUserData(response?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsersByLiability();
  }, []);

  const handlePOpen = (user: any) => {
    setSelectedUser(user);
    setShowModal(true);
    getShowAgent(user?._id);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const getShowAgent = async (user_id: string) => {
    try {
      const payload = {
        user_id: user_id,
      };
      const { response } = await settingServices.getShowAgent(payload);
      setAgentData(response?.data?.agents);
    } catch (error) {
      console.log(error);
    }
  };
  const nav = useNavigate();

  const toggleExposure = (id: string, name: string) => {
    setUserIds(id);
    setExposure(!showExposure);
    setUserName(name);
  };
  return (
    <div className="page-content">
      <div className="closed-user inner-content">
        <BreadCrumb title="Update User Data" pageTitle="Dashboard" back />
        <div className="card">
          <div className="card-body">
            <div className="table-resposive">
              <Table>
                <thead className="table-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Name</th>
                    <th>Liability</th>
                    <th>Balance</th>
                    <th>Settle</th>
                  </tr>
                </thead>
                <tbody>
                  {userData?.length !== 0 ? (
                    userData?.map((items: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{items?.user_name}</td>
                          <td
                            onClick={() =>
                              toggleExposure(items?.user_id, items?.user_name)
                            }
                            className={`cursor-pointer  text-${
                              items?.liability >= 0 ? "success" : "danger"
                            }`}
                          >
                            {items?.liability?.toFixed(2)}
                          </td>
                          <td
                            className={`text-${
                              items?.balance >= 0 ? "success" : "danger"
                            }`}
                          >
                            {items?.balance?.toFixed(2)}
                          </td>
                          <td>
                            <Button
                              variant="info"
                              className="btn-sm me-1"
                              onClick={() => handlePOpen(items)}
                            >
                              P
                            </Button>
                            <Button
                              variant="success"
                              className="btn-sm me-1 text"
                              onClick={() => {
                                nav(
                                  `/downline-report/${items?.user_id}/${items?.user_name}`
                                );
                              }}
                            >
                              R
                            </Button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={2} className="text-center">
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Parent List of {selectedUser?.user_name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <table className="table">
                <tbody>
                  {agent?.map((item: any) => {
                    return (
                      <tr>
                        <td>{`${item?.name} (${item?.user_name})`}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <ExposureModal
        userName={userName}
        userIds={userIds}
        show={showExposure}
        clickHandler={toggleExposure}
      />
    </div>
  );
};

export default UserDataUpdata;
